import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import {
  cornerRadius3XL,
  cornerRadiusXL,
  cornerRadiusXXL,
  space3XL,
  spaceL,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';

import * as Styled from './card-inspire.styles';
import type { CardInspireProps } from './card-inspire.types';

export const CardInspire = React.forwardRef<HTMLDivElement, CardInspireProps>(
  (
    { children, className, padding = 'wide', size = 'auto', variant, ...props },
    forwardedRef
  ): JSX.Element => {
    // FIXME: Move these styles to CSS after Next-Yak migration
    const styles = `
    [data-xds-util="card-container"] {
      container-type: inline-size;
      width: 100%;
    }

    [data-xds-util="card-wide"] {
      border-radius: ${cornerRadiusXL} !important;
      padding-block: ${spaceL} !important;
      padding-inline: ${spaceXL} !important;
      transition: border-radius 0.3s ease;

      @container (min-width: 350px) {
        border-radius: ${cornerRadiusXXL} !important;
        padding-block: ${spaceXL} !important;
        padding-inline: ${spaceXXL} !important;
      }

      @container (min-width: 560px) {
        border-radius: ${cornerRadius3XL} !important;
        padding-block: ${spaceXXL} !important;
        padding-inline: ${space3XL} !important;
      }
    }

    [data-xds-util="card-regular"] > a,
    [data-xds-util="card-wide"] > a {
      border-radius: calc(${cornerRadiusXL} - 2px) !important;

      @container (min-width: 350px) {
        border-radius: calc(${cornerRadiusXXL} - 2px) !important;
      }

      @container (min-width: 560px) {
        border-radius: calc(${cornerRadius3XL} - 2px) !important;
      }
    }

    [data-xds-util="card-regular"] {
      border-radius: ${cornerRadiusXL} !important;
      padding: ${spaceL} !important;
      transition: border-radius 0.3s ease;

      @container (min-width: 350px) {
        border-radius: ${cornerRadiusXXL} !important;
        padding: ${spaceXL} !important;
      }

      @container (min-width: 560px) {
        border-radius: ${cornerRadius3XL} !important;
        padding: ${spaceXXL} !important;
      }
    }

    [data-xds-util="card-none"] {
      border-radius: ${cornerRadiusXL} !important;
      padding: 0 !important;
      transition: border-radius 0.3s ease;

      @container (min-width: 350px) {
        border-radius: ${cornerRadiusXXL} !important;
        padding: 0 !important;
      }

      @container (min-width: 560px) {
        border-radius: ${cornerRadius3XL} !important;
        padding: 0 !important;
      }
    }
  `;

    return (
      <>
        <Helmet>
          <style>{styles}</style>
        </Helmet>
        <Styled.CardContainer
          // FIXME: These data-xds-util are just a temporary solution
          className="is-light-theme"
          data-xds-util={size === 'auto' ? 'card-container' : undefined}
          ref={forwardedRef}
        >
          <Styled.CardInspire
            $variant={variant}
            className={className}
            // FIXME: These data-xds-util are just a temporary solution
            data-xds-util={size === 'auto' ? `card-${padding}` : undefined}
            padding={padding}
            // Only pass size to base Card when it's not 'auto'
            {...(size !== 'auto' && { size })}
            {...props}
          >
            {children}
          </Styled.CardInspire>
        </Styled.CardContainer>
      </>
    );
  }
);

CardInspire.displayName = 'CardInspire';
